<!-- @format -->
<ng-container>
  @if (inputType === "radio-button") {
    <sis-simple-radio-button
      [selected]="selected"
      [id]="actionInputId"
      [name]="actionInputName"
      [label]="module.name | localizedString"
      [visuallyHiddenInfo]="module?.name | localizedString"
      (selectedChange)="toggleSelected()" />
  } @else {
    <sis-checkbox
      [checked]="selected"
      [id]="actionInputId"
      (checkedChange)="toggleSelected()"
      [name]="actionInputName"
      [disabled]="!action"
      [visuallyHiddenInfo]="module?.name | localizedString"
      [label]="
        mandatory
          ? (module?.name | localizedString) +
            ' (' +
            ('PLAN_EDIT.SELECTION_MODAL.RULE_BOX_NOTIFICATION.MANDATORY_SELECTION' | transloco) +
            ')'
          : (module?.name | localizedString)
      ">
    </sis-checkbox>
  }
</ng-container>
